import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getProvincias } from "../../../../../../../redux/actions/direccion";
import { addProveedor } from "../../../../../../../redux/actions/resolucion";
import { handleChangeProvincia } from "../../../../../../commons/formik/direcciones/FormikProvincia";
import ProveedoresForm from "./ProveedoresForm";

const initialValues = {
    razonSocial: "",
    cuit: "",
    esComprador: false,
    pais: "",
    provincia: "",
    localidad: "",
    calle: "",
    km: false,
    numero: "",
    departamento: "",
    piso: "",
    codigoPostal: "",
    entreCalle1: "",
    entreCalle2: "",
}

const ProveedoresFormContainer = ({ formValues, open, handleClose }) => {
    const dispatch = useDispatch();
    const provincias = useSelector((state) => state.direccion.provincias);
    const [values, setValues] = useState();
    const [loadingLocalidad, setLoadingLocalidad] = useState(true);
    const [loadingProvincia, setLoadingProvincia] = useState(true);

    useEffect(() => {
        if (open) {
            if (formValues?.provincia) {
                if (provincias.data.length === 0) {
                    dispatch(getProvincias()).finally(() => {
                        setLoadingProvincia(false);
                    })
                } else {
                    setLoadingProvincia(false);
                }
                handleChangeProvincia(formValues?.provincia, dispatch).finally(() => {
                    setLoadingLocalidad(false);
                });

            } else {
                setLoadingLocalidad(false);
                setLoadingProvincia(false);
            }

            if (formValues) setValues(formValues);
            else {
                setValues(initialValues);
            }
        } else {
            setLoadingLocalidad(true);
            setLoadingProvincia(true);
        }

    }, [formValues, open])

    const id = values?.index ?? null;

    const handleSubmit = (values) => {
        dispatch(addProveedor(values, id))
        handleClose();
    }

    return (
        <ProveedoresForm
            initialFormValues={formValues}
            loading={loadingLocalidad || loadingProvincia}
            open={open}
            handleClose={handleClose}
            handleSubmit={handleSubmit}
            values={values}
            id={id}
        />
    )

}


export default ProveedoresFormContainer;